<template>
  <div class="popup-container" v-if="open">
    <card-dashboard :large="true" class="popup" :title="title" v-click-outside="close">
      <div class="container-content">
        <slot name="default"></slot>
      </div>
      <div class="footer">
        <slot name="footer"></slot>
      </div>
    </card-dashboard>
  </div>
</template>

<script>
import CardDashboard from './CardDashboard'
export default {
  name: 'Popup',
  components: { CardDashboard },
  props: {
    open: {
      type: Boolean
    },
    title: {
      type: String
    }
  },
  methods: {
    close() {
      this.$emit('update:open', false)
    }
  }
}
</script>

<style scoped lang="scss">
.footer {
  padding: 0.5rem;
  background-color: white;
}
.popup-container {
  margin: 0;
  padding: 0;
  .popup {
    position: absolute;
    height: auto;
    width: 450px;
    max-width: 80vw;
    top: calc(52px + 0.75rem + 0.6rem);
    right: 2rem;
    background-color: white;
  }
}
.container-content {
  height: auto;
  max-height: 400px;
  overflow: scroll;
  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.5);
  }
}
</style>
